/** Shared action → chip colour/label mapping used by AuditLogPage + EntityAuditHistory */
export const ACTION_CHIP: Record<string, { label: string; color: 'success' | 'error' | 'warning' | 'info' | 'default' }> = {
  CREATED:        { label: 'Created',        color: 'success' },
  BULK_CREATED:   { label: 'Bulk Created',   color: 'success' },
  ASSIGNED:       { label: 'Assigned',       color: 'success' },
  COMPLETED:      { label: 'Completed',      color: 'success' },
  UPDATED:        { label: 'Updated',        color: 'info' },
  BULK_UPDATED:   { label: 'Bulk Updated',   color: 'info' },
  RECEIVED:       { label: 'Received',       color: 'info' },
  PROCESSED:      { label: 'Processed',      color: 'info' },
  STATUS_CHANGED: { label: 'Status Changed', color: 'warning' },
  CANCELLED:      { label: 'Cancelled',      color: 'error' },
  DELETED:        { label: 'Deleted',        color: 'error' },
};
